import type { ReactNode } from "react";

export const pageTitleClassName =
  "font-display font-semibold tracking-tight text-2xl sm:text-3xl mb-1 bg-gradient-to-r from-[#8a2be2] to-[#ff6a00] bg-clip-text text-transparent";

export default function PageTitle({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) {
  return <h1 className={`${pageTitleClassName} ${className}`.trim()}>{children}</h1>;
}
